import { render } from "./SettingsProfile.vue?vue&type=template&id=5110bc5a"
import script from "./SettingsProfile.vue?vue&type=script&lang=js"
export * from "./SettingsProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__